import { Inject, Injectable, DOCUMENT } from '@angular/core';

import { HttpResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class DownloadService {

  constructor(@Inject(DOCUMENT) private document: Document) {
  }

  private static fetchFileName(blobResponse: HttpResponse<Blob>): string {
    // const fileName = blobResponse.url.split('.')[0].split('/')[5];
    const url = blobResponse.url.split('/');
    const fileName = url[url.length - 1]
    // const contentDisposition = blobResponse.headers.get('content-disposition');
    // const fileName =  contentDisposition.substring(contentDisposition.lastIndexOf('=') + 1);
    // return fileName.slice(1, -1);        // File names come surrounded with quotes in order to support spaces in the names.
    return fileName;
  }

  public download(blobResponse: HttpResponse<Blob>): void {
    const downloadData = new Blob([blobResponse.body], {type: blobResponse.headers.get('Content-Type')});
    const downloadLink = this.document.createElement('a');
    downloadLink.href = URL.createObjectURL(downloadData);
    downloadLink.download = DownloadService.fetchFileName(blobResponse);
    downloadLink.dispatchEvent(new MouseEvent(`click`, {bubbles: true, cancelable: true, view: window}));
  }
}
